import { Roles } from './AppConfiguration';

export const roles: Roles = {
    admin: 'Quoteassist.Admin',
};
